import { ArrowRight2 } from 'iconsax-react';
import type { MouseEvent, PropsWithChildren, ReactNode } from 'react';
import cn from '@/utils/merge-class-names';

type Props = {
  content?: ReactNode;
  chevron?: boolean;
  label?: ReactNode;
  labelClassName?: string;
  labelWrapperClassName?: string;
  prefix?: ReactNode;
  suffix?: ReactNode;
  className?: string;
  hoverable?: boolean;
  onClick?: (e: MouseEvent) => void;
};

const AppCell = ({
  content = '',
  label,
  labelClassName,
  labelWrapperClassName,
  chevron = false,
  prefix,
  suffix,
  className,
  hoverable = false,
  onClick,
  children,
}: PropsWithChildren<Props>) => {
  return (
    <div
      className={cn(
        'flex w-full min-h-12 items-center rounded-s gap-2 px-5 py-3 transition-colors desktop:px-4',
        className,
        {
          'cursor-pointer desktop:hover:bg-base-100': onClick || hoverable,
        },
      )}
      onClick={onClick}>
      {prefix && <div className='flex aspect-square items-center justify-center'>{prefix}</div>}

      {label && (
        <div className={cn('flex flex-1 flex-col items-start gap-1 whitespace-nowrap', labelWrapperClassName)}>
          <div className={cn('text-h2 desktop:text-sm mode-embedded:text-body1', labelClassName)}>{label}</div>{' '}
        </div>
      )}

      {suffix && <div className='flex items-center'>{suffix}</div>}

      {content ? (
        <div className='inline-flex flex-[2] justify-end items-center gap-1 truncate text-h2 mode-embedded:text-body1 desktop:text-sm text-secondary'>
          {content}
        </div>
      ) : (
        children
      )}

      {chevron && (
        <div className='shrink-0'>
          <ArrowRight2
            variant='Outline'
            size={20}
            className='size-5'
          />
        </div>
      )}
    </div>
  );
};

export default AppCell;
